import { render, staticRenderFns } from "./ProductBreadcrumbs.vue?vue&type=template&id=f57ac1d6&scoped=true&"
import script from "./ProductBreadcrumbs.vue?vue&type=script&lang=ts&"
export * from "./ProductBreadcrumbs.vue?vue&type=script&lang=ts&"
import style0 from "./ProductBreadcrumbs.vue?vue&type=style&index=0&id=f57ac1d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f57ac1d6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconsChevronLeft16px: require('/var/www/packages/theme/components/icons/chevron-left/ChevronLeft16px.vue').default})
